(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    

(() => {
  const states = new WeakMap();
  function initialize(section) {
    if (states.has(section)) return;
    const tabs = [...section.querySelectorAll('[role="tab"]')];
    const panels = [...section.querySelectorAll('[role="tabpanel"]')];
    const controller = new AbortController();
    const observers = [];
    const signal = controller.signal;
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    function hydrate(panel) {
      const template = panel.querySelector('template[data-psi-featured-template]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      panel.querySelectorAll('[data-featured-carousel]').forEach(carousel => {
        if (carousel.dataset.carouselReady) return;
        carousel.dataset.carouselReady = 'true';
        const track = carousel.querySelector('[data-carousel-track]');
        const previous = carousel.querySelector('[data-carousel-previous]');
        const next = carousel.querySelector('[data-carousel-next]');
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= Math.max(0, track.scrollWidth - track.clientWidth) - 2;
        };
        const scroll = direction => {
          track.scrollBy({left:direction * track.clientWidth,behavior:reducedMotion() ? 'auto' : 'smooth'});
        };
        previous.addEventListener('click', () => scroll(-1), {signal});
        next.addEventListener('click', () => scroll(1), {signal});
        let frame = 0;
        track.addEventListener('scroll', () => {
          if (frame) return;
          frame = requestAnimationFrame(() => {frame = 0; update();});
        }, {passive:true,signal});
        signal.addEventListener('abort', () => cancelAnimationFrame(frame), {once:true});
        const observer = new ResizeObserver(update);
        observer.observe(track);
        observers.push(observer);
        update();
      });
    }
    function activate(index, focus = false) {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('active',active);
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[i].classList.toggle('active',active);
        panels[i].hidden = !active;
      });
      hydrate(panels[index]);
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => activate(index), {signal});
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(next,true);
      }, {signal});
    });
    if (tabs.length) activate(Math.max(0,tabs.findIndex(t=>t.classList.contains('active'))));
    states.set(section, () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      states.delete(section);
    });
  }
  const sections = root => {
    const result = [...root.querySelectorAll('[data-psi-featured]')];
    if (root.matches?.('[data-psi-featured]')) result.unshift(root);
    return result;
  };
  const load = root => sections(root).forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>load(document),{once:true});
  else load(document);
  document.addEventListener('shopify:section:load',event=>load(event.target));
  document.addEventListener('shopify:section:unload',event=>sections(event.target).forEach(section=>states.get(section)?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-box-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(value){return new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(Number(value||0));}
  function init(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var data=JSON.parse(root.querySelector('[data-box-json]').textContent);
    var labels={choose:root.dataset.choose,from:root.dataset.from,backColors:root.dataset.backColors,backModels:root.dataset.backModels,backCompositions:root.dataset.backCompositions,selectSizes:root.dataset.selectSizes,selected:root.dataset.selected,lookupError:root.dataset.lookupError,minError:root.dataset.minError,cartError:root.dataset.cartError,cartLoading:root.dataset.cartLoading,cartAdd:root.dataset.cartAdd,skuLabel:root.dataset.skuLabel};
    var colorOrder=['Azzurro/Blu','Rosso/Blu','Giallo/Blu','Blu/Bianco','Granata/Nero','Verde/Nero','Nero/Giallo','Nero/Bianco'];
    var colorGrid=root.querySelector('[data-color-grid]');
    var modelGrid=root.querySelector('[data-model-grid]');
    var compositionGrid=root.querySelector('[data-composition-grid]');
    var componentsEl=root.querySelector('[data-components]');
    var summary=root.querySelector('[data-summary]');
    var status=root.querySelector('[data-status]');
    var cartButton=root.querySelector('[data-add-cart]');
    var printButton=root.querySelector('[data-box-print]');
    var dialog=root.querySelector('[data-size-dialog]');
    var dialogTitle=root.querySelector('[data-dialog-title]');
    var dialogSku=root.querySelector('[data-dialog-sku]');
    var dialogImage=root.querySelector('[data-dialog-image]');
    var sizeList=root.querySelector('[data-size-list]');
    var dialogStatus=root.querySelector('[data-dialog-status]');
    var state={color:null,model:null,variant:null,selections:{},activeComponent:null,activeProduct:null};
    /* v435 — visore e barra. ORDINE e' l'unica fonte della numerazione "N/4":
       il titolo e il contatore del passo si ricavano da qui, non sono scritti a mano. */
    var viewerImage=root.querySelector('[data-viewer-image]');
    var navPrev=root.querySelector('[data-nav-prev]');
    var navNext=root.querySelector('[data-nav-next]');
    var stepTitle=root.querySelector('[data-step-title]');
    var stepCount=root.querySelector('[data-step-count]');
    var doneButton=root.querySelector('[data-box-done]');
    var ORDINE=['color','model','composition','sizes'];
    var TITOLI={color:root.dataset.stepColor,model:root.dataset.stepModel,composition:root.dataset.stepComposition,sizes:root.dataset.stepSizes};
    var stageCorrente='color';
    /* I nomi colore del catalogo Givova sono composti: "Azzurro/Blu". La pastiglia
       mostra i due colori a meta' e meta', quindi la tavolozza traduce le parole
       una per una. Un nome non previsto resta grigio invece di sparire. */
    var TAVOLOZZA={azzurro:'#3aa0e0',blu:'#12306e',rosso:'#d92820',giallo:'#f2c500',bianco:'#ffffff',granata:'#7a1220',nero:'#141414',verde:'#0f8f4a',arancio:'#f07f13',rosa:'#e2649a',celeste:'#7cc7ef',grigio:'#9a9a9a',fucsia:'#d81b7a'};
    function tinte(nome){
      var parti=String(nome||'').split('/').map(function(x){return TAVOLOZZA[x.trim().toLowerCase()]||'#b9b9b9';});
      if(parti.length===1)parti.push(parti[0]);
      return parti;
    }
    /* v442 — PRECARICO. Cambiare foto significa cambiare src: se il file non e' gia'
       nella cache del browser, fra il tocco e l'immagine passa il tempo della rete.
       Quindi appena si entra in un passo si scaricano in silenzio tutte le foto che
       quel passo puo' mostrare: i quattro modelli, le quattro composizioni, gli otto
       colori. Al tocco l'immagine e' gia' pronta e il cambio non ha attesa. */
    /* v446 — LE FOTO NON SI MUOVONO PIU'.
       Il riquadro era gia' fisso, ma il contenuto no: Givova inquadra i capi in modo
       leggermente diverso in ogni scatto. Misurate tutte e 111 le foto, il centro del
       contenuto si sposta fino al 3,2% in larghezza e al 3,1% in altezza, e la
       grandezza varia del 4%: e' quel tremolio che si vede cambiando colore.
       Per ogni foto il campo "b" nei dati dice dove sta il contenuto: centro x, centro
       y, larghezza e altezza, in frazioni dell'immagine. Qui si usa per ingrandire e
       spostare la foto quel tanto che serve a far cadere il contenuto sempre nello
       stesso punto. Cambia l'interno, la cornice resta ferma. */
    var riquadri={};
    data.forEach(function(m){m.variants.forEach(function(v){if(v.image&&v.b)riquadri[v.image]=v.b;});});
    /* v449 — INGRANDIMENTO UNICO PER TUTTE.
       Prima ogni foto veniva ingrandita quanto serviva a far riempire il riquadro al
       suo contenuto. Ma i box non hanno tutti lo stesso numero di capi: quelli con
       meno pezzi venivano zoomati di piu' e i capi cambiavano grandezza passando da un
       modello all'altro. Era quello a dare ancora la sensazione di movimento.
       Ora lo zoom e' UNO SOLO per tutte — calcolato sulla misura mediana delle 111
       foto — e per ogni foto si corregge soltanto lo spostamento del centro. Quindi
       i capi restano della stessa grandezza e cadono nello stesso punto. */
    /* v511 — UNA SOLA INQUADRATURA PER TUTTE, anche per il centro. Misurate le 111
       foto: sono tutte 1920x1002 e disegnate sulla stessa sagoma Givova (il fondale
       grigio finisce sempre al 91,1% dell'altezza, i capi stanno sempre negli stessi
       posti). Spostarle una per una sul centro del loro contenuto, come faceva la
       v446, spostava con loro anche il fondale: era quello il movimento che si vedeva
       cambiando colore, modello o composizione, perche' un box con un capo in meno
       ha il contenuto centrato altrove. Ora zoom e centro sono gli stessi per tutte
       (mediana delle 111): la cornice e il fondale restano fermi, cambiano solo i capi. */
    var mediana=(function(){
      var lw=[],lh=[],lx=[],ly=[];
      for(var k in riquadri){lx.push(riquadri[k][0]);ly.push(riquadri[k][1]);lw.push(riquadri[k][2]);lh.push(riquadri[k][3]);}
      function med(a){a.sort(function(x,y){return x-y;});return a.length?a[Math.floor(a.length/2)]:1;}
      return [med(lw),med(lh),lx.length?med(lx):0.5,ly.length?med(ly):0.5];
    }());
    function normalizza(src){
      var b=riquadri[src];
      if(!viewerImage)return;
      if(!b){viewerImage.style.transform='';return;}
      var W=viewerImage.clientWidth,H=viewerImage.clientHeight;
      if(!W||!H)return;
      var r=(viewerImage.naturalWidth&&viewerImage.naturalHeight)?viewerImage.naturalWidth/viewerImage.naturalHeight:1.9162;
      var Wp=Math.min(W,H*r),Hp=Wp/r,ox=(W-Wp)/2,oy=(H-Hp)/2;
      var s=Math.min((W*0.99)/(mediana[0]*Wp),(H*0.98)/(mediana[1]*Hp));
      var cx=ox+mediana[2]*Wp,cy=oy+mediana[3]*Hp;
      viewerImage.style.transform='translate('+(-s*(cx-W/2)).toFixed(1)+'px,'+(-s*(cy-H/2)).toFixed(1)+'px) scale('+s.toFixed(4)+')';
    }
    /* v531 — FOTO LEGGERE E SEMPRE PRONTE.
       1) Misura giusta: gli originali sono 1920x1002 JPG (~150 KB). Si chiede al CDN
          la larghezza che serve davvero (cornice x densita' schermo x zoom), a gradini
          fissi cosi' l'indirizzo resta sempre lo stesso e la cache vale per tutte le
          foto; il CDN la manda in WebP/AVIF. Circa un terzo del peso.
       2) Coda di precarico: al massimo 4 foto alla volta, le urgenti passano davanti.
          Ogni foto scaricata viene anche decodificata, cosi' lo scambio e' immediato.
       3) Cosa si precarica: all'apertura la prima foto di ogni colore; appena libero
          i modelli di tutti i colori; passando sopra un colore (o toccandolo) i suoi
          modelli con precedenza; scelto il colore, i suoi modelli subito e poi tutte le
          sue composizioni; scelto il modello, le sue composizioni subito.
       Le chiavi restano gli indirizzi originali (riquadri, data-image, deeplink):
       la misura si aggiunge solo quando si scarica. */
    var LARG=(function(){
      var w=(viewerImage&&viewerImage.parentNode&&viewerImage.parentNode.clientWidth)||window.innerWidth||1280;
      var t=w*Math.min(window.devicePixelRatio||1,2.5)*1.15,g=[640,960,1280,1600,1920];
      for(var i=0;i<g.length;i++){if(t<=g[i])return g[i];}
      return 1920;
    }());
    function misurata(u){
      if(!u||u.indexOf('cdn.shopify.com')<0&&u.indexOf('/cdn/shop/')<0)return u;
      return u+(u.indexOf('?')>-1?'&':'?')+'width='+LARG;
    }
    var precaricate={},coda=[],inCorso=0,MAXCODA=4;
    function scarica(u,alta){
      var im=precaricate[u];
      if(im){if(alta&&!im._psiFine)try{im.fetchPriority='high';}catch(e){}return im;}
      im=new Image();
      im.decoding='async';
      try{im.fetchPriority=alta?'high':'low';}catch(e){}
      im._psiPronta=new Promise(function(ok){
        function fine(){im._psiFine=true;if(im.naturalWidth>0&&im.decode){im.decode().then(ok,ok);}else ok();}
        im.addEventListener('load',fine,{once:true});
        im.addEventListener('error',fine,{once:true});
      });
      precaricate[u]=im;
      im.src=misurata(u);
      return im;
    }
    function pompa(){
      while(inCorso<MAXCODA&&coda.length){
        var u=coda.shift();
        if(precaricate[u])continue;
        inCorso++;
        scarica(u,false)._psiPronta.then(function(){inCorso--;pompa();});
      }
    }
    function precarica(urls,alta){
      var nuove=[];
      (urls||[]).forEach(function(u){if(u&&!precaricate[u]&&nuove.indexOf(u)<0)nuove.push(u);});
      if(alta){nuove.forEach(function(u){scarica(u,true);});return;}
      nuove.forEach(function(u){if(coda.indexOf(u)<0)coda.push(u);});
      pompa();
    }
    function fotoColore(color){
      var modelli=[],tutte=[];
      data.forEach(function(m){
        var vv=m.variants.filter(function(v){return v.color===color;});
        if(vv.length&&vv[0].image)modelli.push(vv[0].image);
        vv.forEach(function(v){if(v.image)tutte.push(v.image);});
      });
      return {modelli:modelli,tutte:tutte};
    }
    var inAttesa=window.requestIdleCallback||function(f){return setTimeout(f,400);};
    /* passando sopra un colore (computer) o appena lo si tocca (telefono), prima
       ancora del clic: i suoi modelli scaricano con precedenza */
    function anticipa(e){var b=e.target&&e.target.closest&&e.target.closest('[data-action="color"]');if(b)precarica(fotoColore(b.dataset.value).modelli,true);}
    root.addEventListener('pointerover',anticipa,{passive:true});
    root.addEventListener('pointerdown',anticipa,{passive:true});
    root.addEventListener('focusin',anticipa);
    /* v531 — CAMBIO FOTO IN DISSOLVENZA INCROCIATA, stabile anche con tocchi rapidi.
       La foto vecchia viene copiata sopra la nuova (stessa cornice e stessa
       trasformazione) e sfuma solo quando la nuova e' decodificata. Se si tocca di
       nuovo mentre una dissolvenza e' in corso, la copia precedente non viene tolta
       di colpo (era il lampo che si vedeva): finisce la sua dissolvenza, e al massimo
       ne restano due. La foto nuova non si vede mai a meta' caricamento. */
    var riduciMoto=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* v546 — la copia della foto vecchia viene decodificata PRIMA di metterla sopra:
       senza, per un fotogramma la copia era vuota e si vedeva lo scatto. Se nel
       frattempo si e' gia' toccata un'altra scelta, questo cambio si salta. */
    function scambia(src,alt){
      if(!viewerImage.getAttribute('src')||riduciMoto){viewerImage.dataset.orig=src;viewerImage.src=misurata(src);viewerImage.alt=alt||'';normalizza(src);return;}
      var ombre=viewerImage.parentNode.querySelectorAll('.psibox__viewer-ghost');
      for(var i=0;i<ombre.length-1;i++)ombre[i].remove();
      var ombra=viewerImage.cloneNode(false);
      ombra.removeAttribute('data-viewer-image');
      ombra.className='psibox__viewer-img psibox__viewer-ghost';
      ombra.alt='';ombra.setAttribute('aria-hidden','true');
      var pronta=ombra.decode?ombra.decode().catch(function(){}):Promise.resolve();
      pronta.then(function(){
        if(viewerImage.dataset.atteso!==src)return;
        viewerImage.parentNode.appendChild(ombra);
        viewerImage.dataset.orig=src;
        viewerImage.src=misurata(src);viewerImage.alt=alt||'';normalizza(src);
        var via=false;
        function togli(){if(via)return;via=true;ombra.remove();}
        function sfuma(){requestAnimationFrame(function(){requestAnimationFrame(function(){ombra.style.opacity='0';ombra.addEventListener('transitionend',togli,{once:true});setTimeout(togli,800);});});}
        if(viewerImage.decode)viewerImage.decode().then(sfuma,sfuma);else sfuma();
      });
    }
    function setViewer(src,alt){
      if(!viewerImage||!src)return;
      viewerImage.dataset.atteso=src;
      if(viewerImage.dataset.orig===src){viewerImage.alt=alt||'';normalizza(src);return;}
      var im=scarica(src,true);
      if(im._psiFine&&im.naturalWidth>0){scambia(src,alt);return;}
      im._psiPronta.then(function(){if(viewerImage.dataset.atteso===src)scambia(src,alt);});
    }
    /* Dopo una scelta: l'utente resta dov'e' (aggiorno solo frecce e didascalia),
       il deeplink va avanti. Vedi la nota nel gestore dei click. */
    function aggiorna(event,prossimo){
      if(event&&event.isTrusted===false){setStage(prossimo);return;}
      setStage(stageCorrente);
    }
    /* v506 — come Nike la scelta scorre al centro della fila. */
    /* v511 — scorrimento morbido fatto qui, non con behavior:'smooth': su iPhone
       quello nativo veniva interrotto dal ridisegno del passo (che ricentrava di
       colpo) e dall'aggancio scroll-snap, e i colori comparivano di botto.
       420ms con uscita dolce, aggancio sospeso durante il movimento. */
    function centra(el,morbido){
      var fila=el&&el.parentNode;
      if(!fila||fila.scrollWidth<=fila.clientWidth)return;
      var max=fila.scrollWidth-fila.clientWidth;
      var x=Math.max(0,Math.min(max,el.offsetLeft-(fila.clientWidth-el.offsetWidth)/2));
      if(fila._psiAnim){cancelAnimationFrame(fila._psiAnim);fila._psiAnim=0;}
      if(!morbido||riduciMoto||Math.abs(fila.scrollLeft-x)<1){fila.scrollLeft=x;return;}
      var da=fila.scrollLeft,t0=0,dur=420;
      fila.style.scrollSnapType='none';
      function passo(t){
        if(!t0)t0=t;
        var p=Math.min(1,(t-t0)/dur),e=1-Math.pow(1-p,3);
        fila.scrollLeft=da+(x-da)*e;
        if(p<1){fila._psiAnim=requestAnimationFrame(passo);}
        else{fila._psiAnim=0;fila.style.scrollSnapType='';}
      }
      fila._psiAnim=requestAnimationFrame(passo);
    }
    function segnaScelta(action,value){
      var scelto=null;
      root.querySelectorAll('[data-action="'+action+'"]').forEach(function(el){
        el.classList.toggle('is-selected',el.dataset.value===value);
        el.setAttribute('aria-pressed',el.dataset.value===value?'true':'false');
        if(el.dataset.value===value)scelto=el;
      });
      centra(scelto,true);
    }
    var productCache={};

    function setStage(name){
      var daTaglie=(stageCorrente==='sizes'&&name!=='sizes');
      var nuovoPasso=(name!==stageCorrente);
      if(name!==stageCorrente){var pane=root.querySelector('.psibox__pane');if(pane)pane.scrollTop=0;}
      stageCorrente=name;
      root.querySelectorAll('[data-stage]').forEach(function(el){el.hidden=el.dataset.stage!==name;});
      root.dataset.stageAttivo=name;
      var indice=ORDINE.indexOf(name);
      if(stepTitle)stepTitle.textContent=TITOLI[name]||'';
      if(stepCount)stepCount.textContent=(indice+1)+'/'+ORDINE.length;
      /* La freccia sinistra e' attiva se il passo ha un [data-back]: il ritorno resta
         gestito da quel pulsante, qui non si duplica niente.
         La destra e' attiva solo se in questo passo una scelta e' gia' stata fatta,
         perche' andare avanti significa confermarla. */
      var stage=root.querySelector('[data-stage="'+name+'"]');
      if(navPrev)navPrev.disabled=!(stage&&stage.querySelector('[data-back]'));
      var scelto=!!(stage&&stage.querySelector('.is-selected'));
      if(navNext)navNext.disabled=!scelto;
      /* v439 — il pulsante in fondo c'e' SEMPRE, stessa misura e stesso posto: nei
         primi tre passi e' Continua (spento finche' non scegli), al quarto e' il
         carrello. Niente elementi che compaiono o spariscono: era quello a far
         cambiare altezza alla barra. */
      var continua=root.querySelector('[data-nav-continue]');
      if(continua){continua.hidden=(name==='sizes');continua.disabled=!scelto;}
      if(cartButton)cartButton.hidden=(name!=='sizes');
      /* Al passo taglie serve tutto lo spazio: la tendina si apre alzata del tutto,
         e resta solo la riga con "..." e Fine. Negli altri passi torna alla misura
         normale, uguale per tutti e tre. */
      /* v506 — il livello scelto dall'utente resta passando da un passo all'altro,
         come Nike. Solo le taglie aprono la tendina del tutto, e uscendo dalle taglie
         torna normale. */
      if(name==='sizes')poni(2);else if(daTaglie||livello===undefined)poni(1);
      var sel=stage&&stage.querySelector('.is-selected');
      if(sel&&nuovoPasso)requestAnimationFrame(function(){centra(sel,false);});
      aggiornaInfo();posaNome();disegnaPassi();
    }
    /* v517 — COMPUTER COME NIKE BY YOU. */
    function desktop(){return window.matchMedia('(min-width: 901px)').matches;}
    var infoName=root.querySelector('[data-info-name]'),infoPrice=root.querySelector('[data-info-price]');
    /* nome e prezzo in alto a sinistra: il box scelto, oppure il prezzo di partenza */
    function aggiornaInfo(){
      if(!infoName)return;
      infoName.textContent=state.model?state.model.name:'Box Grandi Forniture';
      var prezzo='';
      if(state.variant)prezzo=money(state.variant.price);
      else{
        var lista=(state.model?state.model.variants:allVariants().map(function(x){return x.variant;})).filter(function(v){return !state.color||v.color===state.color;});
        if(lista.length)prezzo=labels.from+' '+money(Math.min.apply(null,lista.map(function(v){return Number(v.price);})));
      }
      infoPrice.textContent=prezzo;
    }
    /* il nome del colore sta sotto la pastiglia scelta, come Nike */
    function posaNome(){
      var st=root.querySelector('[data-stage="color"]'),sw=st&&st.querySelector('.psibox__swatch.is-selected');
      if(!st)return;
      if(!sw){st.style.removeProperty('--psibox-cx');return;}
      var a=st.getBoundingClientRect(),b=sw.getBoundingClientRect();
      if(!a.width)return;
      st.style.setProperty('--psibox-cx',Math.round(b.left-a.left+b.width/2)+'px');
    }
    window.addEventListener('resize',posaNome);
    /* elenco dei passi del vassoio "Menu" */
    var passiBox=root.querySelector('[data-steps]'),passiLista=root.querySelector('[data-steps-list]'),passiApri=root.querySelector('[data-steps-open]');
    function fatto(nome){return nome==='color'?!!state.color:nome==='model'?!!state.model:nome==='composition'?!!state.variant:false;}
    function disegnaPassi(){
      if(!passiLista)return;
      passiLista.innerHTML='';
      var aperto=true;
      ORDINE.forEach(function(nome,i){
        var li=document.createElement('li'),b=document.createElement('button');
        b.type='button';b.dataset.stepGo=nome;b.disabled=!aperto;
        if(fatto(nome))li.className='is-done';
        if(nome===stageCorrente)li.className+=' is-current';
        var dot=document.createElement('i'),t=document.createElement('span'),v=document.createElement('em');
        t.textContent=TITOLI[nome]||nome;
        v.textContent=nome==='color'?(state.color||''):nome==='model'?(state.model?state.model.name.replace(/^Box\s+/i,''):''):nome==='composition'?(state.variant?state.variant.composition:''):'';
        b.append(dot,t,v);li.appendChild(b);passiLista.appendChild(li);
        aperto=aperto&&fatto(nome);
      });
    }
    function apriPassi(){if(!passiBox)return;disegnaPassi();passiBox.classList.add('is-open');passiBox.setAttribute('aria-hidden','false');var x=passiBox.querySelector('.psibox__steps-x');if(x)x.focus({preventScroll:true});}
    function chiudiPassi(){if(!passiBox||!passiBox.classList.contains('is-open'))return;passiBox.classList.remove('is-open');passiBox.setAttribute('aria-hidden','true');if(passiApri)passiApri.focus({preventScroll:true});}
    if(passiApri)passiApri.addEventListener('click',apriPassi);
    if(passiBox)passiBox.addEventListener('click',function(e){
      if(e.target.closest('[data-steps-close]')){chiudiPassi();return;}
      var go=e.target.closest('[data-step-go]');
      if(go&&!go.disabled){chiudiPassi();setStage(go.dataset.stepGo);}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')chiudiPassi();});
    aggiornaInfo();
    /* v435 — al posto delle card con foto: pastiglia bicolore per il colore,
       pillola con nome e prezzo per modello e composizione. La foto non sta piu'
       nel pulsante, sta nel visore: ogni pulsante la porta in data-image e il
       gestore dei click la passa a setViewer. */
    function card(image,title,meta,action,value){
      var button=document.createElement('button');
      button.type='button';button.dataset.action=action;button.dataset.value=value;
      button.dataset.image=image||'';button.setAttribute('aria-pressed','false');
      if(action==='color'){
        button.className='psibox__swatch';
        button.setAttribute('aria-label',title);
        button.title=title;
        var c=tinte(title);
        var disco=document.createElement('span');
        disco.className='psibox__swatch-disc';
        disco.style.background='linear-gradient(90deg,'+c[0]+' 0 50%,'+c[1]+' 50% 100%)';
        button.appendChild(disco);
        return button;
      }
      button.className='psibox__chip';
      var strong=document.createElement('strong');strong.textContent=title;
      button.appendChild(strong);
      if(meta&&meta!==labels.choose){var span=document.createElement('span');span.textContent=meta;button.appendChild(span);}
      return button;
    }
    function allVariants(){return data.reduce(function(list,model){return list.concat(model.variants.map(function(v){return{model:model,variant:v};}));},[]);}
    function renderColors(){
      colorGrid.innerHTML='';
      var prima=null;
      colorOrder.forEach(function(color){
        var match=allVariants().find(function(item){return item.variant.color===color;});
        if(!match)return;
        if(!prima)prima=match;
        colorGrid.appendChild(card(match.variant.image,color,labels.choose,'color',color));
      });
      /* Il visore non parte mai vuoto: senza una scelta mostra la prima combinazione
         disponibile, cosi' la sezione si apre gia' con un prodotto in pagina. */
      if(prima&&!state.color)setViewer(prima.variant.image,prima.model.name+' '+prima.variant.color);
      precarica(Array.prototype.map.call(colorGrid.children,function(b){return b.dataset.image;}),true);
      /* appena il browser e' libero: i modelli di tutti i colori, in coda */
      inAttesa(function(){colorOrder.forEach(function(c){precarica(fotoColore(c).modelli);});});
    }
    function renderModels(){
      modelGrid.innerHTML='';
      data.forEach(function(model){
        var variants=model.variants.filter(function(v){return v.color===state.color;});
        if(!variants.length)return;
        var min=Math.min.apply(null,variants.map(function(v){return Number(v.price);}));
        modelGrid.appendChild(card(variants[0].image,model.name.replace(/^Box\s+/i,''),labels.from+' '+money(min),'model',model.key));
      });
      var fc=fotoColore(state.color);precarica(fc.modelli,true);precarica(fc.tutte);
      root.querySelector('[data-model-title]').textContent=state.color;
      root.querySelector('[data-back="color"]').textContent=labels.backColors;
    }
    function renderCompositions(){
      compositionGrid.innerHTML='';
      var variants=state.model.variants.filter(function(v){return v.color===state.color;});
      variants.forEach(function(v){compositionGrid.appendChild(card(v.image,v.composition,money(v.price),'composition',v.sku));});precarica(variants.map(function(v){return v.image;}),true);
      root.querySelector('[data-composition-title]').textContent=state.model.name+' — '+state.color;
      root.querySelector('[data-back="model"]').textContent=labels.backModels;
    }
    function selectionTotal(sku){
      var values=state.selections[sku]||{};return Object.keys(values).reduce(function(sum,id){return sum+Number(values[id]||0);},0);
    }
    /* v512 — taglia di una variante ("M", "XL", "UNICA") e ordine delle taglie. */
    var ORDINE_TAGLIE=['7XS','6XS','5XS','4XS','3XS','2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL','JUNIOR','SENIOR','UNICA'];
    function tagliaDi(v){var t=String(v.public_title||v.title||'').toUpperCase().split('/');return t[t.length-1].trim();}
    function ordinaTaglie(a,b){var ai=ORDINE_TAGLIE.indexOf(a),bi=ORDINE_TAGLIE.indexOf(b);if(ai<0)ai=999;if(bi<0)bi=999;return ai-bi||a.localeCompare(b,'it',{numeric:true});}
    /* riepilogo per la riga: "M×8 · L×6" */
    function riepilogoTaglie(sku){
      var values=state.selections[sku]||{},prodotto=productCache[sku],parti=[];
      Object.keys(values).forEach(function(id){
        var v=prodotto&&prodotto.variants.find(function(x){return String(x.id)===String(id);});
        parti.push({t:v?tagliaDi(v):'',n:Number(values[id]||0)});
      });
      parti.sort(function(a,b){return ordinaTaglie(a.t,b.t);});
      return parti.map(function(x){return x.t==='UNICA'?x.n+' pz':(x.t?x.t+'×'+x.n:x.n+' pz');}).join(' · ');
    }
    function aggiornaRiga(sku){
      var row=componentsEl.querySelector('[data-component-sku="'+CSS.escape(sku)+'"]');if(!row)return;
      var fatto=selectionTotal(sku)>0;
      row.classList.toggle('is-done',fatto);
      var c=row.querySelector('[data-chosen]');if(c)c.textContent=fatto?riepilogoTaglie(sku):'Da scegliere';
      var b=row.querySelector('[data-select-sku]');if(b)b.textContent=fatto?'Modifica':labels.selectSizes;
    }
    var progressEl=root.querySelector('[data-progress]');
    function refreshCartState(){
      if(!state.variant){cartButton.disabled=true;return;}
      var comps=state.variant.components;
      var fatti=comps.filter(function(c){return selectionTotal(c.sku)>0;}).length;
      var pezzi=comps.reduce(function(t,c){return t+selectionTotal(c.sku);},0);
      if(progressEl)progressEl.innerHTML=fatti+' di '+comps.length+' <span>completati</span>';
      var invalid=fatti<comps.length;
      cartButton.disabled=invalid;
      if(cartButton.getAttribute('aria-busy')!=='true')cartButton.textContent=pezzi>0?labels.cartAdd+' · '+pezzi+' pz':labels.cartAdd;
      if(!invalid&&!status.dataset.keep)status.textContent='';
    }
    /* spunte e pillola "Scegli taglie in blocco" */
    var bulkBtn=root.querySelector('[data-bulk]'),bulkCount=root.querySelector('[data-bulk-count]'),selAll=root.querySelector('[data-select-all]');
    function spuntati(){return Array.prototype.map.call(componentsEl.querySelectorAll('[data-pick]:checked'),function(x){return x.dataset.pick;});}
    function aggiornaSpunte(){
      var n=spuntati().length,tot=componentsEl.querySelectorAll('[data-pick]').length;
      if(bulkBtn){bulkBtn.hidden=n===0;if(bulkCount)bulkCount.textContent=String(n);}
      if(selAll)selAll.textContent=(n&&n===tot)?'Deseleziona':'Seleziona tutti';
    }
    function renderComponents(savedSelections){
      state.selections=savedSelections||{};componentsEl.innerHTML='';
      /* v439 — riepilogo su una riga: la foto e' nel visore sopra, ripeterla qui
         mangiava l'altezza della barra. Nome della combinazione + prezzo. */
      summary.textContent=state.model.name+' · '+state.color+' · '+state.variant.composition;
      var prezzo=document.createElement('strong');prezzo.className='psibox__summary-price';prezzo.textContent=money(state.variant.price);
      summary.append(' ',prezzo);
      state.variant.components.forEach(function(component){
        var row=document.createElement('article');row.className='psibox__component';row.dataset.componentSku=component.sku;
        var pick=document.createElement('label');pick.className='psibox__pick';var box=document.createElement('input');box.type='checkbox';box.dataset.pick=component.sku;box.setAttribute('aria-label','Seleziona '+(component.name||component.sku));pick.append(box,document.createElement('span'));
        var media=document.createElement('div');media.className='psibox__component-media';var thumb=document.createElement('img');thumb.decoding='async';thumb.alt=component.name||component.sku;thumb.hidden=true;thumb.addEventListener('load',function(){thumb.classList.add('is-loaded');});media.appendChild(thumb);
        var text=document.createElement('div');text.className='psibox__component-info';var h=document.createElement('h4');h.textContent=component.name||component.sku;var chosen=document.createElement('p');chosen.className='psibox__chosen';chosen.dataset.chosen='';text.append(h,chosen);
        var btn=document.createElement('button');btn.type='button';btn.dataset.selectSku=component.sku;btn.textContent=labels.selectSizes;row.append(pick,media,text,btn);componentsEl.appendChild(row);
        aggiornaRiga(component.sku);
        loadProduct(component).then(function(product){component.name=product.title;component.image=product.image||component.image;h.textContent=product.title;thumb.alt=product.title;box.setAttribute('aria-label','Seleziona '+product.title);if(component.image){thumb.src=component.image;thumb.hidden=false;}aggiornaRiga(component.sku);}).catch(function(){});
      });
      aggiornaSpunte();
      root.querySelector('[data-back="composition"]').textContent=labels.backCompositions;refreshCartState();
    }
    /* v541 — la foto di ogni capo arriva dallo SKU: si legge il prodotto, si prende la
       variante il cui SKU inizia con quello del capo (articolo-colore) e si usa la sua
       foto. Se l'indirizzo del prodotto cambia, lo si ritrova cercando lo SKU. */
    async function loadProduct(component){
      if(productCache[component.sku])return productCache[component.sku];
      var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var sku=component.sku.toUpperCase();var variants=[];var seen={};var letti={};var image='';
      async function leggi(handle){
        if(!handle||letti[handle])return;letti[handle]=true;
        var response=await fetch(base+'products/'+handle+'.js',{headers:{Accept:'application/json'}});
        if(!response.ok)return;var product=await response.json();
        product.variants.forEach(function(v){var value=String(v.sku||'').toUpperCase();if((value===sku||value.indexOf(sku+'-')===0)&&!seen[value]){seen[value]=true;variants.push(v);if(!image&&v.featured_image&&v.featured_image.src)image=v.featured_image.src;}});
      }
      for(var i=0;i<(component.handles||[]).length;i++){await leggi(component.handles[i]);}
      if(!variants.length){
        try{var r=await fetch(base+'search/suggest.json?q='+encodeURIComponent(sku)+'&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku',{headers:{Accept:'application/json'}});
          if(r.ok){var j=await r.json();var ps=(j&&j.resources&&j.resources.results&&j.resources.results.products)||[];for(var k=0;k<ps.length;k++){await leggi(ps[k].handle);}}}catch(e){}
      }
      if(!variants.length)throw new Error('not-found');
      var result={title:component.name||component.sku,image:image,variants:variants};productCache[component.sku]=result;return result;
    }
    var applyBtn=root.querySelector('[data-apply-sizes]'),applyLabel=applyBtn?applyBtn.textContent:'';
    /* il campo mostra 0; al tocco si svuota, cosi' si scrive subito il numero */
    function campoQuantita(input){
      input.addEventListener('focus',function(){if(input.value==='0')input.value='';});
      input.addEventListener('blur',function(){if(input.value==='')input.value='0';});
    }
    function prossimoDaFare(dopo){
      var comps=state.variant?state.variant.components:[],i=comps.indexOf(dopo);
      for(var k=1;k<=comps.length;k++){var c=comps[(i+k)%comps.length];if(c!==dopo&&selectionTotal(c.sku)<1)return c;}
      return null;
    }
    function animaFoglio(){sizeList.classList.remove('is-swap');void sizeList.offsetWidth;sizeList.classList.add('is-swap');}
    async function openSizes(component){
      dialog.dataset.mode='single';if(applyBtn)applyBtn.textContent=prossimoDaFare(component)?'Conferma e avanti':applyLabel;
      state.activeComponent=component;dialogTitle.textContent=component.name||component.sku;dialogSku.textContent=labels.skuLabel+' '+component.sku;dialogImage.hidden=true;if(component.image){dialogImage.src=component.image;dialogImage.alt=component.name||component.sku;dialogImage.hidden=false;}dialogStatus.textContent='';sizeList.innerHTML='';if(!dialog.open)dialog.showModal();else animaFoglio();/* v446 — all'apertura il browser mette il fuoco sul primo pulsante, cioe' la x, e la disegna con l'alone azzurro. Lo togliamo subito: il fuoco resta comunque raggiungibile da tastiera. */var xChiudi=dialog.querySelector('.psibox__dialog-close');if(xChiudi&&xChiudi.blur)xChiudi.blur();
      try{
        var product=await loadProduct(component);state.activeProduct=product;component.name=product.title;component.image=product.image||component.image;dialogTitle.textContent=product.title;if(component.image){dialogImage.src=component.image;dialogImage.alt=product.title;dialogImage.hidden=false;}
        var sizeKey=tagliaDi;
        var orderedVariants=product.variants.filter(function(v){return v.available;}).sort(function(a,b){return ordinaTaglie(tagliaDi(a),tagliaDi(b));});
        sizeList.style.setProperty('--psi-size-count',String(Math.max(1,orderedVariants.length)));
        orderedVariants.forEach(function(v){
          var row=document.createElement('label');row.className='psibox__size';var name=document.createElement('strong');name.className='psibox__size-name';/* v441 — solo la taglia: il colore e' gia' scritto in cima al foglio, ripeterlo su ogni riga ("GRANATA/NERO / 4XS") allunga e non aggiunge nulla. */name.textContent=sizeKey(v)||v.public_title||v.title;
          var input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.inputMode='numeric';input.pattern='[0-9]*';input.enterKeyHint='done';input.autocomplete='off';input.setAttribute('aria-label','Quantità '+(v.public_title||v.title));input.dataset.variantId=String(v.id);input.value=String((state.selections[component.sku]||{})[v.id]||0);campoQuantita(input);row.append(name,input);sizeList.appendChild(row);
        });
        if(!sizeList.children.length)throw new Error('unavailable');
      }catch(error){dialogStatus.textContent=labels.lookupError;}
    }
    function applySizes(){
      if(dialog.dataset.mode==='bulk'){applicaBlocco();return;}
      if(!state.activeComponent)return;var values={};sizeList.querySelectorAll('[data-variant-id]').forEach(function(input){var quantity=Math.max(0,Math.floor(Number(input.value||0)));if(quantity>0)values[input.dataset.variantId]=quantity;});
      state.selections[state.activeComponent.sku]=values;var total=selectionTotal(state.activeComponent.sku);
      aggiornaRiga(state.activeComponent.sku);refreshCartState();
      if(total<1){dialogStatus.textContent=labels.minError.replace('__count__',String(total));return;}
      var dopo=prossimoDaFare(state.activeComponent);
      if(dopo){openSizes(dopo);return;}
      dialog.close();
    }
    /* v512 — TAGLIE IN BLOCCO. Il foglio mostra l'unione delle taglie disponibili dei
       capi spuntati; le quantita' scritte valgono per ognuno. I capi a taglia unica
       (borsa, cappello...) prendono la riga "Taglia unica", che da sola segue il
       totale finche' non la si cambia a mano. Se un capo non ha una taglia, quella
       quantita' per lui viene saltata e lo si dice alla fine. */
    function stepper(input){
      var w=document.createElement('div');w.className='psibox-pro-stepper';
      var meno=document.createElement('button'),piu=document.createElement('button');meno.type=piu.type='button';meno.textContent='−';piu.textContent='+';
      function passo(d){var n=Math.max(0,(parseInt(input.value,10)||0)+d);input.value=String(n);input.dispatchEvent(new Event('input',{bubbles:true}));}
      meno.addEventListener('click',function(){passo(-1);});piu.addEventListener('click',function(){passo(1);});
      w.append(meno,input,piu);return w;
    }
    function nuovoCampo(){var input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.inputMode='numeric';input.pattern='[0-9]*';input.enterKeyHint='done';input.autocomplete='off';input.value='0';campoQuantita(input);return input;}
    async function apriBlocco(){
      var skus=spuntati();if(!skus.length||!state.variant)return;
      var comps=state.variant.components.filter(function(c){return skus.indexOf(c.sku)>=0;});
      dialog.dataset.mode='bulk';state.activeComponent=null;
      dialogTitle.textContent='Taglie in blocco';dialogSku.textContent=comps.length===1?'1 articolo selezionato':comps.length+' articoli selezionati';
      dialogImage.hidden=true;dialogStatus.textContent='';sizeList.innerHTML='';if(applyBtn)applyBtn.textContent='Applica a '+(comps.length===1?'1 articolo':comps.length+' articoli');
      if(!dialog.open)dialog.showModal();var x=dialog.querySelector('.psibox__dialog-close');if(x&&x.blur)x.blur();
      var totale=dialog.querySelector('.psibox-pro-size-total strong');
      try{
        var prodotti=await Promise.all(comps.map(loadProduct));
        var taglie={},unici=[];
        prodotti.forEach(function(pr,i){
          var disp=pr.variants.filter(function(v){return v.available;});
          if(disp.length&&disp.every(function(v){return tagliaDi(v)==='UNICA';}))unici.push(pr.title||comps[i].name);
          else disp.forEach(function(v){var t=tagliaDi(v);if(t&&t!=='UNICA')taglie[t]=true;});
        });
        var campi=[],unica=null;
        function somma(){return campi.reduce(function(t,c){return t+(parseInt(c.value,10)||0);},0);}
        function ricalcola(){var s=somma();if(unica&&!unica.dataset.toccato)unica.value=String(s);if(totale)totale.textContent=(s+(unica?parseInt(unica.value,10)||0:0))+' pezzi';}
        Object.keys(taglie).sort(ordinaTaglie).forEach(function(t){
          var row=document.createElement('label');row.className='psibox__size';var nome=document.createElement('strong');nome.className='psibox__size-name';nome.textContent=t;
          var input=nuovoCampo();input.dataset.bulkSize=t;input.setAttribute('aria-label','Quantità '+t);input.addEventListener('input',ricalcola);campi.push(input);
          row.append(nome,stepper(input));sizeList.appendChild(row);
        });
        if(unici.length){
          var row=document.createElement('label');row.className='psibox__size';var nome=document.createElement('strong');nome.className='psibox__size-name';nome.textContent='Taglia unica';
          var hint=document.createElement('span');hint.className='psibox__size-hint';hint.textContent=unici.join(', ');nome.appendChild(hint);
          unica=nuovoCampo();unica.dataset.bulkSize='UNICA';unica.setAttribute('aria-label','Quantità taglia unica');
          unica.addEventListener('input',function(){unica.dataset.toccato='1';ricalcola();});
          row.append(nome,stepper(unica));sizeList.appendChild(row);
        }
        ricalcola();setTimeout(ricalcola,0);
        if(!sizeList.children.length)throw new Error('vuoto');
      }catch(e){dialogStatus.textContent=labels.lookupError;}
    }
    function applicaBlocco(){
      var q={};sizeList.querySelectorAll('[data-bulk-size]').forEach(function(i){var n=Math.max(0,Math.floor(Number(i.value||0)));if(n)q[i.dataset.bulkSize]=n;});
      if(!Object.keys(q).length){dialogStatus.textContent='Scrivi almeno una quantità.';return;}
      var skus=spuntati(),mancanti=[];
      state.variant.components.forEach(function(c){
        if(skus.indexOf(c.sku)<0)return;var pr=productCache[c.sku];if(!pr)return;
        var disp=pr.variants.filter(function(v){return v.available;}),values={},saltate=[];
        var soloUnica=disp.length&&disp.every(function(v){return tagliaDi(v)==='UNICA';});
        if(soloUnica){if(q.UNICA)values[disp[0].id]=q.UNICA;}
        else Object.keys(q).forEach(function(t){if(t==='UNICA')return;var v=disp.find(function(x){return tagliaDi(x)===t;});if(v)values[v.id]=q[t];else saltate.push(t);});
        state.selections[c.sku]=values;aggiornaRiga(c.sku);
        if(saltate.length)mancanti.push((pr.title||c.name)+': '+saltate.join(', '));
      });
      componentsEl.querySelectorAll('[data-pick]:checked').forEach(function(x){x.checked=false;});aggiornaSpunte();
      dialog.close();refreshCartState();
      status.dataset.keep='1';
      status.textContent=mancanti.length?'Taglie non disponibili, saltate — '+mancanti.join(' · '):'Taglie applicate a '+(skus.length===1?'1 articolo':skus.length+' articoli')+'.';
      status.dataset.proTone=mancanti.length?'error':'ok';
      setTimeout(function(){delete status.dataset.keep;},100);
    }
    function draft(){
      if(!state.model||!state.variant)return null;
      return{version:1,color:state.color,model:state.model.key,variant:state.variant.sku,selections:state.selections,savedAt:new Date().toISOString()};
    }
    function draftText(value){
      if(!value)return '';
      var model=data.find(function(item){return item.key===value.model;});
      var variant=model&&model.variants.find(function(item){return item.sku===value.variant;});
      if(!model||!variant)return '';
      var lines=['Configurazione Planet Sport Italia',model.name+' — '+value.color+' — '+variant.composition,'Codice: '+variant.sku];
      variant.components.forEach(function(component){
        var selected=(value.selections||{})[component.sku]||{};
        var total=Object.keys(selected).reduce(function(sum,id){return sum+Number(selected[id]||0);},0);
        lines.push((component.name||component.sku)+': '+total+' pezzi');
      });
      return lines.join('\n');
    }
    function restoreDraft(value){
      if(!value||value.version!==1)return false;
      var model=data.find(function(item){return item.key===value.model;});
      var variant=model&&model.variants.find(function(item){return item.sku===value.variant&&item.color===value.color;});
      if(!model||!variant)return false;
      state.color=value.color;state.model=model;state.variant=variant;
      renderComponents(value.selections||{});
      setStage('sizes');
      status.textContent='Configurazione ripristinata.';
      return true;
    }
    function storageAllowed(){
      var privacy=window.Shopify&&window.Shopify.customerPrivacy;
      return !privacy||typeof privacy.preferencesProcessingAllowed!=='function'||privacy.preferencesProcessingAllowed();
    }
    /* v444 — Qui c'erano saveDraft, shareUrl, shareDraft e whatsappDraft, cioe' i tre
       comandi del menu "..." (salva sul dispositivo, condividi link, invia su
       WhatsApp). Rimossi con i loro pulsanti: restano il preventivo e il carrello.
       restoreDraft e storageAllowed restano perche' servono ancora al ripristino di
       una configurazione aperta da un link con #box=. */
    async function addToCart(){
      refreshCartState();if(cartButton.disabled){status.textContent=labels.minError.replace('__count__','0');return;}
      cartButton.disabled=true;cartButton.setAttribute('aria-busy','true');cartButton.textContent=labels.cartLoading;var group='BOX-'+Date.now();var items=[];
      state.variant.components.forEach(function(component){var chosen=state.selections[component.sku]||{};Object.keys(chosen).forEach(function(id){items.push({id:Number(id),quantity:Number(chosen[id]),properties:{'_psi_box_group':group,'Box':state.model.name,'Colore':state.color,'Composizione':state.variant.composition}});});});
      try{
        var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        if(!response.ok)throw new Error('cart');
        /* v513 — si resta nel configuratore e compare l'avviso "Aggiunto al carrello"
           del sito (foglio dal basso sul telefono, riquadro in alto a destra sul
           computer), con il riepilogo del box: foto, colore, composizione, articoli,
           pezzi e totale. La vecchia fascia .psibox__toast e' stata cancellata. */
        var pezzi=items.reduce(function(t,i){return t+i.quantity;},0);
        /* v514 — dopo l'aggiunta si esce dal configuratore: "Visualizza carrello"
           porta a Grandi Forniture con il carrello gia' aperto, chiudere l'avviso
           riporta a Grandi Forniture. */
        var uscita=root.dataset.exitUrl||'/collections/grandi-forniture';
        if(window.psiCartConfirm)window.psiCartConfirm.show({group:group,title:state.model.name,image:state.variant.image,meta:['Colore '+state.color,'Composizione '+state.variant.composition],trigger:cartButton,cartHref:uscita+'#carrello',onClose:function(){window.location.assign(uscita);}});
        else status.textContent=(pezzi===1?'1 articolo aggiunto al carrello':pezzi+' articoli aggiunti al carrello');
        cartButton.removeAttribute('aria-busy');refreshCartState();
        if(typeof window.psiTrack==='function')window.psiTrack('box_configurator_add',{pezzi:pezzi});
      }catch(error){status.textContent=labels.cartError;cartButton.removeAttribute('aria-busy');refreshCartState();}
    }
    root.addEventListener('click',function(event){
      /* v438 — COME NIKE BY YOU: toccare una scelta aggiorna la foto e RESTA nel passo.
         Si va avanti con la freccia destra o con Continua. Prima ogni tocco saltava al
         passo successivo, quindi la scelta non si vedeva nemmeno.
         L'unica eccezione e' il clic non fidato (event.isTrusted false), cioe' quello
         che psi-box-deeplink genera da codice arrivando dalle pagine Box: la' la
         sequenza deve scorrere fino alle taglie da sola, come prima. */
      var color=event.target.closest('[data-action="color"]');if(color){state.color=color.dataset.value;segnaScelta('color',state.color);setViewer(color.dataset.image,state.color);var tc=root.querySelector('[data-color-title]');if(tc)tc.textContent=state.color;renderModels();aggiorna(event,'model');return;}
      var model=event.target.closest('[data-action="model"]');if(model){state.model=data.find(function(item){return item.key===model.dataset.value;});segnaScelta('model',model.dataset.value);setViewer(model.dataset.image,state.model.name+' '+state.color);var tm=root.querySelector('[data-model-title]');if(tm)tm.textContent=state.model.name;renderCompositions();aggiorna(event,'composition');return;}
      var composition=event.target.closest('[data-action="composition"]');if(composition){state.variant=state.model.variants.find(function(item){return item.sku===composition.dataset.value;});segnaScelta('composition',composition.dataset.value);setViewer(composition.dataset.image,state.model.name+' '+state.color+' '+state.variant.composition);var tk=root.querySelector('[data-composition-title]');if(tk)tk.textContent='Composizione '+state.variant.composition+' · '+money(state.variant.price);renderComponents();aggiorna(event,'sizes');return;}
      var back=event.target.closest('[data-back]');if(back){setStage(back.dataset.back);return;}
      var select=event.target.closest('[data-select-sku]');if(select){var component=state.variant.components.find(function(item){return item.sku===select.dataset.selectSku;});if(component)openSizes(component);}
    });
    /* Frecce della barra. Nessuna logica nuova: la sinistra clicca il [data-back] del
       passo, la destra riclicca la scelta gia' fatta, che e' esattamente cio' che
       porta avanti il configuratore. Cosi' anche il deeplink continua a passare per
       la stessa strada. */
    if(navPrev)navPrev.addEventListener('click',function(){
      var back=root.querySelector('[data-stage="'+stageCorrente+'"] [data-back]');
      if(back)back.click();
    });
    /* v506 — TENDINA COME NIKE. Tre posizioni:
         0 giu'    — resta solo la testa (maniglia + riga del passo), foto grande
         1 normale — la misura dei passi 1-3
         2 tutta   — la barra arriva sotto Preventivo/Fine e la foto sparisce
       Il gesto: la barra segue il dito fotogramma per fotogramma (un solo
       aggiornamento per frame, niente transizioni durante il gesto), oltre i limiti
       fa resistenza come un elastico, e al rilascio decide la velocita': uno
       strappo verso l'alto o verso il basso porta alla posizione successiva in
       quella direzione, altrimenti si va alla piu' vicina. Poi scorre fino a li'
       con la transizione del CSS partendo esattamente da dove e' il dito.
       Un tocco sulla testa (fuori dalle frecce) alterna: giu' -> normale -> tutta
       -> normale.
       Le versioni v441/v443/v444 (livello "alzata", presa catturata al primo tocco
       che rubava i click, niente velocita') sono state sostituite da questa. */
    var sheet=root;
    var livello;
    function poni(n){
      livello=Math.max(0,Math.min(2,n));
      sheet.classList.toggle('is-collapsed',livello===0);
      sheet.classList.toggle('is-full',livello===2);
    }
    /* v517 — freccia del vassoio su computer: giu' resta solo la riga del passo */
    var trayBtn=root.querySelector('[data-tray-toggle]');
    if(trayBtn)trayBtn.addEventListener('click',function(){
      poni(livello===0?1:0);
      trayBtn.setAttribute('aria-expanded',livello===0?'false':'true');
      trayBtn.setAttribute('aria-label',livello===0?'Espandi il pannello':'Riduci il pannello');
    });
    var bar=root.querySelector('.psibox__bar');
    var head=root.querySelector('[data-bar-head]');
    var cornice=viewerImage&&viewerImage.parentNode;
    function misuraTesta(){
      if(!bar||!head)return;
      var pt=parseFloat(getComputedStyle(bar).paddingTop)||0;
      bar.style.setProperty('--psibox-hc',Math.round(head.offsetHeight+pt+8)+'px');
    }
    misuraTesta();
    window.addEventListener('resize',misuraTesta);
    /* stesse formule del CSS (--psibox-hc, --psibox-h0, --psibox-h2) */
    function altezze(){
      var H=window.innerHeight,desk=window.matchMedia('(min-width: 901px)').matches;
      var hc=parseFloat(bar.style.getPropertyValue('--psibox-hc'))||110;
      return [hc, desk?230:Math.min(Math.max(300,H*0.40),380), H-70];
    }
    if(head&&bar){
      var gesto=null,frame=0,hVoluta=0;
      function disegna(){
        frame=0;
        bar.style.height=hVoluta+'px';
        if(cornice){
          var L=altezze(),p=(hVoluta-L[1])/(L[2]-L[1]);
          cornice.style.opacity=p>0?String(Math.max(0,1-p*1.3)):'';
        }
      }
      head.addEventListener('pointerdown',function(e){
        if(gesto||(e.pointerType==='mouse'&&e.button!==0)||e.target.closest('button')||desktop())return;
        gesto={id:e.pointerId,y0:e.clientY,h0:bar.getBoundingClientRect().height,y:e.clientY,t:e.timeStamp,v:0,mosso:false};
      });
      head.addEventListener('pointermove',function(e){
        if(!gesto||e.pointerId!==gesto.id)return;
        var dy=gesto.y0-e.clientY;
        if(!gesto.mosso){
          if(Math.abs(dy)<4)return;
          gesto.mosso=true;
          try{head.setPointerCapture(e.pointerId);}catch(err){}
          sheet.classList.add('is-dragging');
        }
        var dt=e.timeStamp-gesto.t;
        if(dt>0)gesto.v=0.7*((gesto.y-e.clientY)/dt)+0.3*gesto.v;
        gesto.y=e.clientY;gesto.t=e.timeStamp;
        var L=altezze(),h=gesto.h0+dy;
        if(h<L[0])h=L[0]-(L[0]-h)*0.3;
        if(h>L[2])h=L[2]+(h-L[2])*0.3;
        hVoluta=h;
        if(!frame)frame=requestAnimationFrame(disegna);
      });
      function fineGesto(e){
        if(!gesto||e.pointerId!==gesto.id)return;
        var g=gesto;gesto=null;
        if(frame){cancelAnimationFrame(frame);frame=0;}
        if(!g.mosso){
          if(e.type==='pointerup')poni(livello===0?1:(livello===1?2:1));
          return;
        }
        /* fermo da piu' di 90ms prima di alzare il dito: niente strappo */
        if(e.timeStamp-g.t>90)g.v=0;
        var L=altezze(),h=bar.getBoundingClientRect().height,dove;
        if(g.v>0.45)dove=h<L[1]-8?1:2;
        else if(g.v<-0.45)dove=h>L[1]+8?1:0;
        else{var d=Infinity;L.forEach(function(v,i){var q=Math.abs(v-h);if(q<d){d=q;dove=i;}});}
        sheet.classList.remove('is-dragging');
        poni(dove);
        bar.style.height=h+'px';
        void bar.offsetHeight;
        bar.style.height='';
        if(cornice)cornice.style.opacity='';
      }
      head.addEventListener('pointerup',fineGesto);
      head.addEventListener('pointercancel',fineGesto);
    }
    /* v505 — la cornice cambia misura anche quando la barra sale o scende, non solo
       col ridimensionamento della finestra: la normalizzazione la segue. */
    (function(){
      function rifai(){normalizza(viewerImage&&viewerImage.dataset.orig);}
      var cornice=viewerImage&&viewerImage.parentNode;
      if(window.ResizeObserver&&cornice)new ResizeObserver(rifai).observe(cornice);
      else window.addEventListener('resize',rifai);
    }());
    function avanti(){
      var passo=ORDINE[ORDINE.indexOf(stageCorrente)+1];
      if(passo)setStage(passo);
    }
    if(navNext)navNext.addEventListener('click',avanti);
    var goBtn=root.querySelector('[data-nav-continue]');
    if(goBtn)goBtn.addEventListener('click',avanti);
    /* "Fine": chiude il configuratore e riporta alla card BOX. Non tocca lo stato,
       quindi riaprendolo si ritrova la configurazione dov'era. */
    /* v436 — il configuratore vive su una pagina sua a schermo pieno, quindi "Fine"
       esce dalla pagina. Se il visitatore e' arrivato da Grandi Forniture torna
       indietro nella cronologia (ritrova la posizione di scorrimento); altrimenti va
       all'indirizzo di Grandi Forniture. */
    /* v453 — FINE.
       Prima provava a tornare indietro nella cronologia quando il visitatore arrivava
       dal sito: e' li' che a volte non funzionava, perche' la pagina precedente poteva
       non essere Grandi Forniture (o non esserci affatto, se il link era stato aperto
       da fuori). Ora va sempre all'indirizzo di Grandi Forniture: prevedibile.
       E se qualcosa e' gia' stato scelto, prima chiede. */
    var leaveDialog=root.querySelector('[data-leave-dialog]');
    var leaveText=root.querySelector('[data-leave-text]');
    function scelteFatte(){
      var n=0;
      if(state.color)n++;
      if(state.model)n++;
      if(state.variant)n++;
      Object.keys(state.selections||{}).forEach(function(sku){
        var q=state.selections[sku]||{};
        if(Object.keys(q).some(function(k){return Number(q[k])>0;}))n++;
      });
      return n;
    }
    function esci(){window.location.href=root.dataset.exitUrl||'/';}
    if(doneButton)doneButton.addEventListener('click',function(){
      var n=scelteFatte();
      if(!n||!leaveDialog){esci();return;}
      if(leaveText)leaveText.textContent=n===1
        ? 'Hai gia’ fatto una scelta: uscendo la perdi.'
        : 'Hai gia’ fatto '+n+' scelte: uscendo le perdi.';
      leaveDialog.showModal();
      var x=leaveDialog.querySelector('[data-leave-stay]');if(x&&x.blur)x.blur();
    });
    if(leaveDialog){
      var stay=leaveDialog.querySelector('[data-leave-stay]');
      var go=leaveDialog.querySelector('[data-leave-go]');
      if(stay)stay.addEventListener('click',function(){leaveDialog.close();});
      if(go)go.addEventListener('click',esci);
      leaveDialog.addEventListener('click',function(e){if(e.target===leaveDialog)leaveDialog.close();});
    }
    root.querySelector('[data-apply-sizes]').addEventListener('click',applySizes);
    componentsEl.addEventListener('change',function(e){if(e.target.matches('[data-pick]'))aggiornaSpunte();});
    if(selAll)selAll.addEventListener('click',function(){var tutte=componentsEl.querySelectorAll('[data-pick]'),on=spuntati().length!==tutte.length;tutte.forEach(function(x){x.checked=on;});aggiornaSpunte();});
    if(bulkBtn)bulkBtn.addEventListener('click',apriBlocco);
    cartButton.addEventListener('click',addToCart);
    printButton.addEventListener('click',function(){if(!draft()){status.textContent='Completa prima la configurazione.';return;}window.print();if(typeof window.psiTrack==='function')window.psiTrack('box_configurator_print',{});});
    renderColors();
    /* v435 — la barra parte impostata: senza questa chiamata titolo e contatore
       restano vuoti finche' non si tocca qualcosa. */
    setStage('color');
    var restored=false;
    try{
      var hash=new URLSearchParams(window.location.hash.slice(1)).get('box');
      if(hash)restored=restoreDraft(JSON.parse(hash));
      if(!restored&&storageAllowed()){var saved=localStorage.getItem('psi_box_draft_v1');if(saved)restoreDraft(JSON.parse(saved));}
    }catch(error){}
  }
  document.querySelectorAll('[data-psi-box]').forEach(init);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-complete-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root){
    if(root.dataset.lookReady)return;root.dataset.lookReady='true';
    const track=root.querySelector('.psi-look-track'),dialog=root.querySelector('dialog');
    if(!track||!dialog)return;
    // Generate each outfit from available candidates, matching the anchor palette.
    // The product pool is rendered by Liquid, so prices/links/stock remain Shopify's.
    const cards=Array.from(track.children);let visit=0;
    const rotate=root.dataset.lookRotation==='true'&&!window.Shopify?.designMode;
    if(rotate){
      if(window.psiLookVisitV4===undefined){
        try{const n=Number(sessionStorage.getItem('psi-look-visit-v4')||0);window.psiLookVisitV4=Number.isSafeInteger(n)&&n>=0?n:0;sessionStorage.setItem('psi-look-visit-v4',String((window.psiLookVisitV4+1)%600));}
        catch(e){window.psiLookVisitV4=Math.floor(Date.now()/86400000);}
      }
      visit=window.psiLookVisitV4;
    }
    const affinity=(tone,anchor)=>tone===anchor?3:(tone==='black'||tone==='white'||tone==='equipment'?1:0);
    cards.forEach(card=>{
      const pool=Array.from(card.querySelectorAll('template[data-look-slot]'));
      const slots=[...new Set(pool.map(t=>t.dataset.lookSlot))];let anchor='';const selected=[];
      for(const slot of slots){
        const candidates=pool.filter(t=>t.dataset.lookSlot===slot);
        const best=anchor?Math.max(...candidates.map(t=>affinity(t.dataset.lookTone,anchor))):3;
        const matches=anchor?candidates.filter(t=>affinity(t.dataset.lookTone,anchor)===best&&best>0):candidates;
        if(!matches.length){card.hidden=true;return;}
        const chosen=matches[(visit+Number(slot)-1)%matches.length];
        if(!anchor)anchor=chosen.dataset.lookTone;
        selected.push(chosen);
      }
      if(selected.length!==Number(card.dataset.lookSlots)){card.hidden=true;return;}
      const canvas=card.querySelector('.psi-look-canvas'),eye=canvas.querySelector('.psi-look-all');
      canvas.querySelectorAll('.psi-look-piece,.psi-look-popup').forEach(e=>e.remove());
      selected.forEach(t=>canvas.insertBefore(t.content.cloneNode(true),eye));
      card.dataset.lookPalette=anchor;
    });
    const visible=cards.filter(c=>!c.hidden);
    if(rotate&&visible.length){const offset=visit%visible.length;visible.slice(offset).concat(visible.slice(0,offset)).forEach(c=>track.append(c));}
    if(!visible.length){root.hidden=true;return;}
    const closePopups=()=>{root.querySelectorAll('.psi-look-popup').forEach(x=>x.hidden=true);root.querySelectorAll('.psi-look-hotspot').forEach(x=>x.setAttribute('aria-expanded','false'));};
    function updateArrows(){root.querySelector('[data-look-direction="-1"]').disabled=track.scrollLeft<2;root.querySelector('[data-look-direction="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
    let previousFocus=null;
    function openLook(card,trigger){
      closePopups();const items=dialog.querySelector('.psi-look-dialog-items');items.replaceChildren();
      card.querySelectorAll('.psi-look-popup').forEach(link=>{
        const row=document.createElement('article');row.className='psi-look-sheet-item';
        const photo=document.createElement('a');photo.href=link.href;photo.className='psi-look-sheet-photo';photo.tabIndex=-1;photo.setAttribute('aria-hidden','true');
        const img=document.createElement('img');img.src=link.dataset.lookPhoto;img.alt='';img.width=240;img.height=300;img.decoding='async';photo.append(img);
        const info=document.createElement('div');info.className='psi-look-sheet-info';
        const title=document.createElement('h3');title.textContent=link.querySelector('strong').textContent;
        const type=document.createElement('p');type.textContent=link.dataset.lookType;
        const price=document.createElement('b');price.textContent=link.querySelector('b').textContent;
        const buy=document.createElement('a');buy.className='psi-look-buy';buy.href=link.href;buy.textContent=link.dataset.lookBuy;buy.setAttribute('aria-label',buy.textContent+' '+title.textContent);
        info.append(title,type,price,buy);row.append(photo,info);items.append(row);
      });
      previousFocus=trigger;document.body.classList.add('psi-look-open');dialog.showModal();
    }
    root.addEventListener('click',event=>{
      const hot=event.target.closest('.psi-look-hotspot');
      if(hot){const open=hot.getAttribute('aria-expanded')==='true';closePopups();if(!open){hot.setAttribute('aria-expanded','true');document.getElementById(hot.getAttribute('aria-controls')).hidden=false;}return;}
      const arrow=event.target.closest('[data-look-direction]');
      if(arrow){const first=Array.from(track.children).find(c=>!c.hidden),gap=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:Number(arrow.dataset.lookDirection)*((first?.getBoundingClientRect().width||track.clientWidth)+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});return;}
      const all=event.target.closest('.psi-look-all');if(all)openLook(all.closest('.psi-look-card'),all);
    });
    dialog.addEventListener('click',e=>{if(e.target.closest('.psi-look-close'))dialog.close();else if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{document.body.classList.remove('psi-look-open');previousFocus?.focus({preventScroll:true});});
    document.addEventListener('click',e=>{if(!e.target.closest('.psi-look-hotspot,.psi-look-popup'))closePopups();});
    root.addEventListener('keydown',e=>{if(e.key==='Escape')closePopups();});
    track.addEventListener('scroll',()=>{closePopups();updateArrows();},{passive:true});new ResizeObserver(updateArrows).observe(track);updateArrows();
  }
  document.querySelectorAll('.psi-complete-look').forEach(setup);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.psi-complete-look').forEach(setup));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-help-center"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
var root=document.querySelector('[data-help-center]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
var input=root.querySelector('#ph-search'),form=root.querySelector('.ph-search'),status=root.querySelector('.ph-search-status'),articles=Array.from(root.querySelectorAll('[data-help-article]')),empty=root.querySelector('.ph-empty');
var normalize=function(s){return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[’']/g,' ');};
var index=articles.map(function(el){return {el:el,text:normalize(el.textContent+' '+el.dataset.keywords)};});
function corporateView(on){root.classList.toggle('ph-corporate-view',on);articles.forEach(function(el){el.hidden=on&&el.id!=='info-legali-societarie';});root.querySelector('.ph-quick').hidden=on;root.querySelector('.ph-contact').hidden=on;empty.hidden=true;}
function search(){corporateView(false);var words=normalize(input.value).trim().split(/\s+/).filter(Boolean),count=0;index.forEach(function(item){var match=words.every(function(word){return item.text.includes(word);});item.el.hidden=!match;if(words.length)item.el.open=match;else item.el.open=false;if(match)count++;});root.querySelector('.ph-quick').hidden=words.length>0;root.querySelector('.ph-contact').hidden=words.length>0;empty.hidden=!words.length||count>0;status.textContent=words.length?status.dataset.resultsLabel+': '+count:'';}
input.addEventListener('input',search);
form.addEventListener('submit',function(e){e.preventDefault();search();root.querySelector('.ph-articles').scrollIntoView({block:'start'});});
function openTarget(hash,focus){var id;try{id=decodeURIComponent((hash||'').replace(/^#/,''));}catch(e){return;}if(!id)return;var target=document.getElementById(id);if(!target||!root.contains(target))return;if(input.value){input.value='';search();}corporateView(id==='info-legali-societarie');if(id==='info-legali-societarie'){target.open=true;window.scrollTo({top:0,behavior:'instant'});if(focus){var title=target.querySelector('h2');title.setAttribute('tabindex','-1');title.focus({preventScroll:true});}return;}if(target.matches('details'))target.open=true;var parent=target.parentElement.closest('details');if(parent)parent.open=true;requestAnimationFrame(function(){target.scrollIntoView({block:'start'});if(focus){var el=target.querySelector('summary')||target;el.setAttribute('tabindex','-1');el.focus({preventScroll:true});}});}
document.addEventListener('click',function(e){var a=e.target.closest('a[href]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;var url=new URL(a.href,location.href);if(url.origin===location.origin&&url.pathname===location.pathname&&url.hash&&document.getElementById(url.hash.slice(1))){e.preventDefault();history.pushState(null,'',url.hash);openTarget(url.hash,true);}});
window.addEventListener('hashchange',function(){openTarget(location.hash,false);});
var result=root.querySelector('[data-form-result]');if(result){openTarget('#scrivici',false);}else if(location.hash){openTarget(location.hash,false);}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
